const CROCKFORD = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';

let lastTime = -1;
let lastRandom: number[] = [];

function randomDigits(count: number): number[] {
  const bytes = new Uint8Array(count);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b & 31);
}

function incrementDigits(digits: number[]): number[] {
  const next = digits.slice();
  for (let i = next.length - 1; i >= 0; i--) {
    const d = next[i]!;
    if (d < 31) {
      next[i] = d + 1;
      return next;
    }
    next[i] = 0;
  }
  return next;
}

/**
 * Monotonic ULID: 10 characters of millisecond time followed by 16 random characters.
 * IDs made in the same millisecond still sort in creation order.
 */
export function ulid(now: number = Date.now()): string {
  let random: number[];
  if (now <= lastTime) {
    random = incrementDigits(lastRandom);
    now = lastTime;
  } else {
    random = randomDigits(16);
  }
  lastTime = now;
  lastRandom = random;
  let time = '';
  let t = now;
  for (let i = 0; i < 10; i++) {
    time = CROCKFORD[t % 32] + time;
    t = Math.floor(t / 32);
  }
  return time + random.map((d) => CROCKFORD[d]).join('');
}

export type IdPrefix =
  | 'trp'
  | 'itm'
  | 'plc'
  | 'att'
  | 'src'
  | 'chg'
  | 'hb'
  | 'dev'
  | 'mut'
  | 'ses'
  | 'prg'
  | 'crd'
  | 'prk'
  | 'rdm'
  | 'bal';

export function newId(prefix: IdPrefix, now?: number): string {
  return `${prefix}_${ulid(now)}`;
}

/** Random URL-safe token with the given number of random bytes. */
export function randomToken(bytes = 32): string {
  const buf = new Uint8Array(bytes);
  crypto.getRandomValues(buf);
  let bin = '';
  for (const b of buf) bin += String.fromCharCode(b);
  return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
